"use strict";
// Structural types for the runnit-fields heal/extract helpers.
//
// These mirror the shapes defined on RunnitNodeField / RunnitNodeFieldGroup
// in `shared/src/types/firebase.ts` but are intentionally re-declared here
// so this leaf module has no runtime dependency on firebase / lodash /
// moment (the constraint that lets the plugin bundle it cleanly).
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldKeyOf = fieldKeyOf;
exports.isGroupNode = isGroupNode;
exports.isFieldNode = isFieldNode;
// The three accessors below are written without `?.` / `??`: web's webpack-4
// parser reads the symlinked shared dist without transpiling it, and cannot
// parse either operator. Same constraint as kits/resolveKit and
// analytics/identity.
/** The key this leaf's value is stored under, in either spelling. */
function fieldKeyOf(node) {
    if (!node)
        return undefined;
    return node.fieldKey === undefined || node.fieldKey === null
        ? node.fieldDefUuid
        : node.fieldKey;
}
function isGroupNode(node) {
    return !!node && (node.isGroup === true || node.__rgroup === true);
}
function isFieldNode(node) {
    return !!node && (node.isField === true || node.__rfield === true);
}
